'use client';

import { FC, ReactNode, useState } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { createQueryClient } from '@telialt/utils/src/query-client';

type Props = {
    children: ReactNode;
};

export const QueryProvider: FC<Props> = ({ children }) => {
    const [queryClient] = useState(() => createQueryClient());

    return (
        <QueryClientProvider client={queryClient}>
            {process.env.IS_RQ_DEVTOOLS_ON === 'true' && <ReactQueryDevtools initialIsOpen={false} position="bottom" />}
            {children}
        </QueryClientProvider>
    );
};
